// The module cache
const __webpack_module_cache__ = {};

// The require function
function __webpack_require__(moduleId) {
	// Check if module is in cache
	const cachedModule = __webpack_module_cache__[moduleId];
	if (cachedModule !== undefined) {
		return cachedModule.exports;
	}
	// Create a new module (and put it into the cache)
	let module = __webpack_module_cache__[moduleId] = {
		id: moduleId,
		loaded: false,
		exports: {}
	};

	// Execute the module function
	const execOptions = { id: moduleId, module: module, factory: __webpack_modules__[moduleId], require: __webpack_require__ };
	__webpack_require__.i.forEach(function(handler) { handler(execOptions); });
	if (!execOptions.factory) {
		delete __webpack_module_cache__[moduleId];
		const e = new Error("Cannot find module '" + moduleId + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	module = execOptions.module;
	execOptions.factory.call(module.exports, module, module.exports, execOptions.require);

	// Flag the module as loaded
	module.loaded = true;

	// Return the exports of the module
	return module.exports;
}

// expose the modules object (__webpack_modules__)
__webpack_require__.m = __webpack_modules__;

// expose the module cache
__webpack_require__.c = __webpack_module_cache__;

// expose the module execution interceptor
__webpack_require__.i = [];

